"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISMISS_NOTIFICATION = exports["default"] = void 0;
var DISMISS_NOTIFICATION = 'WEB_CHAT/DISMISS_NOTIFICATION';
exports.DISMISS_NOTIFICATION = DISMISS_NOTIFICATION;

function dismissNotification(id) {
  return {
    type: DISMISS_NOTIFICATION,
    payload: {
      id: id
    }
  };
}

var _default = dismissNotification;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2Rpc21pc3NOb3RpZmljYXRpb24uanMiXSwibmFtZXMiOlsiRElTTUlTU19OT1RJRklDQVRJT04iLCJkaXNtaXNzTm90aWZpY2F0aW9uIiwiaWQiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBTUEsb0JBQW9CLEdBQUcsK0JBQTdCOzs7QUFFQSxTQUFTQyxtQkFBVCxDQUE2QkMsRUFBN0IsRUFBaUM7QUFDL0IsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVILG9CQUREO0FBRUxJLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxFQUFFLEVBQUZBO0FBQUY7QUFGSixHQUFQO0FBSUQ7O2VBRWNELG1CIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgRElTTUlTU19OT1RJRklDQVRJT04gPSAnV0VCX0NIQVQvRElTTUlTU19OT1RJRklDQVRJT04nO1xuXG5mdW5jdGlvbiBkaXNtaXNzTm90aWZpY2F0aW9uKGlkKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogRElTTUlTU19OT1RJRklDQVRJT04sXG4gICAgcGF5bG9hZDogeyBpZCB9XG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IGRpc21pc3NOb3RpZmljYXRpb247XG5cbmV4cG9ydCB7IERJU01JU1NfTk9USUZJQ0FUSU9OIH07XG4iXX0=